import { useSearchParams } from 'react-router-dom'
import { LIS_REVIEW_PARAM } from '@/lib/lisReview'
import { LisReviewDialog } from './LisReviewDialog'

/**
 * Opens the review dialog for `?lisReview=<resultId>`, the target of a LIS
 * review notification. Closing it removes the param so a refresh does not
 * reopen it.
 */
export function LisReviewDeepLink({
  onDecided,
  currentSubmissionId,
}: {
  onDecided?: (outcome: 'approved' | 'rejected') => void
  /** The form open on the page, so the review does not link to itself. */
  currentSubmissionId?: string | null
}) {
  const [searchParams, setSearchParams] = useSearchParams()
  const resultId = searchParams.get(LIS_REVIEW_PARAM)
  return (
    <LisReviewDialog
      resultId={resultId}
      onClose={() =>
        setSearchParams(
          (prev) => {
            const next = new URLSearchParams(prev)
            next.delete(LIS_REVIEW_PARAM)
            return next
          },
          { replace: true },
        )
      }
      onDecided={onDecided}
      currentSubmissionId={currentSubmissionId}
    />
  )
}
